export default {
  title: 'Users',
  addUser: 'Add User',
  editUser: 'Edit User',
  deleteUser: 'Delete User',
  userDetails: 'User Details',
  userInformation: 'User Information',
  userList: 'User List',
  name: 'Name',
  email: 'Email',
  phone: 'Phone',
  role: 'Role',
  department: 'Department',
  position: 'Position',
  status: 'Status',
  createdAt: 'Created At',
  lastLogin: 'Last Login',
  actions: 'Actions',
  roles: {
    title: 'Roles',
    addRole: 'Add Role',
    editRole: 'Edit Role',
    deleteRole: 'Delete Role',
    roleName: 'Role Name',
    permissions: 'Permissions',
    assignPermissions: 'Assign Permissions'
  },
  permissions: {
    title: 'Permissions',
    view: 'View',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    manage: 'Manage'
  },
  departments: {
    title: 'Departments',
    addDepartment: 'Add Department',
    editDepartment: 'Edit Department',
    deleteDepartment: 'Delete Department',
    departmentName: 'Department Name',
    manager: 'Manager',
    description: 'Description'
  },
  team: {
    title: 'Team',
    members: 'Team Members',
    addMember: 'Add Member',
    removeMember: 'Remove Member'
  }
}

